import React from 'react';

import styled, { css } from 'styled-components';

import { Component as QuantityBadge } from '../QuantityBadge';

import { Caret } from './MemberCreditsDesktopButtonCaret';

const expandedStyling = css`
  &[aria-expanded='true'] {
    ${QuantityBadge} {
      background: ${props => props.theme.colors.active};
    }

    & ${Caret} {
      transform: translateY(-1px) rotate(0deg);
    }

    &::after {
      background: ${({ theme }) => theme.colors.lavender};
    }
  }
`;

const MemberCreditsDesktopButtonV2 = styled.div`
  ${({ theme }) => theme.links.variants.navbarLink}
  display: flex;
  align-items: baseline;
  gap: 8px;
  ${expandedStyling}
`;

export function MemberCreditsDesktopButton({
  showCaret,
  children,
  isOpen,
  ...props
}) {
  const isOpenDerivativeProps = {
    isOpen,
    'aria-expanded': isOpen ? 'true' : undefined,
  };

  return (
    <MemberCreditsDesktopButtonV2 {...props} {...isOpenDerivativeProps}>
      {children}
      {showCaret && <Caret />}
    </MemberCreditsDesktopButtonV2>
  );
}
